import { TableProps } from 'Components/Table/Table/Table';

type TableControlsProps<T> = Pick<TableProps<T>, 'enablePagination' | 'enableColumnRemove'>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const disableTableColumnControls: TableControlsProps<any> = {
  enablePagination: false,
  enableColumnRemove: false
};

export const DEFAULT_TABLE_PAGE_SIZE = 50;
